module.exports = __webpack_public_path__ + "img/chevron.a20ad00d.svg";